/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/RadioButtons/_components/RadioButton.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React from "react";
import {getImage} from "../../../../_utils";

export default function RadioButton({
  id,
  groupName,
  name,
  option,
  onChange,
  value,
}) {

  const checked = (option.value + "") === (value + "");

  return (
    <div className={`gc__radio_button_container ${groupName}--radio-wrapper`}>
      <input
        className={`gc__radio_input ${groupName}--radio-input`}
        type="radio"
        id={`${groupName}_${id}`}
        name={name}
        value={option.value}
        onChange={onChange}
        checked={checked}
      />
      <label 
        className={`gc__radio_label ${groupName}--radio-label`}
        htmlFor={`${groupName}_${id}`}
      >
        {(option.icon) ?
          <img 
            src={getImage(option.icon)}
            alt=""
            className={`gc__radio-icon ${groupName}--radio-icon`}
          />
        : null}
        {option.label}
      </label>
    </div>
  )
}
